<template>
  <!--begin::details View-->
  <div class="card mb-5 mb-xl-10" id="kt_profile_details_view">
    <!--begin::Card header-->
    <div class="card-header cursor-pointer">
      <!--begin::Card title-->
      <div class="card-title m-0">
        <h3 class="fw-bolder m-0">Please confirm</h3>
      </div>
      <!--end::Card title--> 
    </div>
    <!--begin::Card header-->

    <!--begin::Card body-->
    <div class="card-body p-9">
      <!--begin::Row-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">First Name/Middle Name/Last Name</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <span class="fw-bolder fs-6 text-dark">{{formdata.insured_firstName}}/{{formdata.insured_middleName}}/{{formdata.insured_lastName}}</span>
        </div>
        <!--end::Col-->
      </div> 

      <!--end::Row-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">Birth Date</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <span class="fw-bolder fs-6 text-dark">{{formdata.insured_birthday}}</span>
        </div>
        <!--end::Col-->
      </div>
      <!--end::Row-->

      <!--end::Row-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">Username</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <span class="fw-bolder fs-6 text-dark">{{formdata.username}}</span>
        </div>
        <!--end::Col-->
      </div>
      <!--end::Row-->

 

          

 
    

      <div v-if="false"
        class="notice d-flex bg-light-warning rounded border-warning border border-dashed  p-6"
      >
        <span class="svg-icon svg-icon-2tx svg-icon-warning me-4">
          <inline-svg src="media/icons/duotone/Code/Warning-1-circle.svg" />
        </span>
        <!--begin::Wrapper-->
        <div class="d-flex flex-stack flex-grow-1 ">
          <!--begin::Content-->
          <div class=" fw-bold">
            <h4 class="text-gray-800 fw-bolder">BIBO Endorser Registration Confirmation</h4>

            <div class="fs-6 text-gray-600 ">
              {{userFname}}, you are about to register {{formdata.insured_firstName.toUpperCase()}} {{formdata.insured_lastName.toUpperCase()}} as your BIBO Endorser.
              
                <div class="pt-5" v-if="formdata.uplineid !=  formdata.responsedata.actualuplineid">
                    Your original requested upline is  <a class="fw-bolder" href="javascript:;"> {{formdata.responsedata.requesteduplinename}} ({{formdata.uplineid}}) </a>
                </div>
                <div class="pt-5">
                    Please click Submit to proceed.
                </div>               
            </div>
          </div>
          <!--end::Content-->
        </div>
        <!--end::Wrapper-->
      </div>
    </div>
    <!--end::Card body-->
  </div>
  <!--end::details View-->




</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
 

export default defineComponent({
  name: "account-overview",
  components: { 
  },
    props: { 
        formdata: Object,
        userFname : String
  },
  setup() {
    onMounted(() => { 


    });
  }
});
</script>
